import request from './request'

export function adminLogin(body) {
  return request.post('/api/admin/auth/password', body)
}